<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-28 11:06:42
-->
<template>
	<div class="sourceCell">
		<div v-if="row['source_type'] == '1'">
			<div>{{ (row['partner_name'] || row['contact_name']) + '(ID：' + (row['account_id'] || row['contact_id']) + ')' }}</div>
			<div>货盘表：{{ row['pallet_name'] + '(ID：' + row['pallet_id'] + ')' }}</div>
		</div>
		<div v-else>
			<div class="fz-12">{{ zsName }}：{{ row['partner_name'] || row['partner_role_name'] || '-' }}</div>
			<div class="fz-12 yx-color-text-p-4">来源：{{ row['source_type_desc'] }}</div>
			<div class="fz-12" v-if="isFristTeam">团长：{{ row.origin_institution_name || '-' }}</div>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
import { zsRoleType } from '@/utils/dataMap';
export default {
	mixins: [mixin],
	computed: {
		zsName() {
			return zsRoleType.name;
		},
		isFristTeam({ row }) {
			return +row.product_type === 4;
		},
	},
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
</style>
